import styled from 'styled-components';

export const Row = styled.div`
  display: contents;
`;

export const Cell = styled.div`
  display: flex;
  align-items: center;

  height: 32px;
  padding-right: 16px;

  white-space: nowrap;

  border-bottom: 1px solid ${({ theme }) => theme.colors.greys.light};
`;

export const LinkIcon = styled.div`
  width: 16px;
  height: 16px;

  background: url('/images/inpulse/icon-open-in-new-black.svg') no-repeat;

  cursor: pointer;

  &:hover {
    background: url('/images/inpulse/icon-open-in-new-green.svg') no-repeat;
  }
`;
